import { call, put, take, takeLatest } from 'redux-saga/effects';

import { STORAGE_KEYS } from '@constants';
import { initData, updateDataInStorage } from '@core/storage';
import { ViewPermissions } from '@enums';
import {
  appInitError,
  changeSystemAuthenticated,
  getUserSummary,
  getUserSummarySuccess,
  getWorkspaceOptions,
  getWorkspaceOptionsSuccess,
  logOut,
  setAppLoading,
  updateToken,
} from '@store';
import { API } from '@utils';

export interface TokenResponse {
  access_token: string;
  expires_in: number;
  id_token: string;
  refresh_token: string;
  token_type: string;
}

function* getUserSummarySaga() {
  try {
    const { data: userData } = yield call(API.get, '/user/info');

    yield put(getWorkspaceOptions());
    yield take(getWorkspaceOptionsSuccess);

    if (userData) {
      yield call(
        updateDataInStorage,
        initData,
        ['userEmail', 'userId', 'firstName', 'lastName', 'createdAt', 'updatedAt'],
        {
          userEmail: userData?.email,
          userId: userData?.id,
          firstName: userData?.first_name,
          lastName: userData?.last_name,
          createdAt: userData?.created_at,
          updatedAt: userData?.updated_at,
        },
      );
    }

    yield call([localStorage, 'setItem'], STORAGE_KEYS.LOGOUT, 'false');
    yield put(changeSystemAuthenticated(true));
    yield put(
      getUserSummarySuccess({
        ...userData,
        roles: 'ROLE_SUPERADMIN',
        permissions: [
          ViewPermissions.ViewCdn,
          ViewPermissions.ViewConfiguration,
          ViewPermissions.ViewDashboard,
          ViewPermissions.ViewHomepage,
          ViewPermissions.ViewProfileSetings,
          ViewPermissions.ViewWorkspace,
        ],
      }),
    );
  } catch (error: any) {
    console.error('Error fetching user summary:', error);
    if (error.response && error.response.status === 401) {
      yield put(updateToken());
    } else {
      yield put(appInitError('Error fetching user data'));
      yield put(logOut());
    }
  } finally {
    yield put(setAppLoading(false));
  }
}

export function* userSagaWatcher() {
  yield takeLatest(getUserSummary.type, getUserSummarySaga);
}
